<script>
import BarGraphStatisticAttestation from "./BarGraphStatisticAttestation.vue";

export default {
  name: "TheCardUniversityStatisticAttestation",
  components: {BarGraphStatisticAttestation},

}
</script>

<template>
<!--  <v-card>-->

<!--    <v-card-text v-if="loading" class="d-flex align-center justify-center" style="height: 500px">-->
<!--      <v-progress-circular-->
<!--        :size="70"-->
<!--        :width="7"-->
<!--        color="teal darken-3"-->
<!--        indeterminate-->
<!--      ></v-progress-circular>-->
<!--    </v-card-text>-->

<!--    <template v-else>-->
<!--      <v-card-title>-->
<!--        {{statistics.meta.departmentName}}-->
<!--      </v-card-title>-->
<!--      <v-card-text>-->
<!--        <v-tabs-->
<!--          v-model="tab"-->
<!--          centered-->
<!--          color="teal darken-3"-->
<!--        >-->
<!--          <v-tab-->
<!--            v-for="dateAttestation in statistics.dateAttestations"-->
<!--            :key="`${statistics.meta.departmentName}-${dateAttestation.date}`"-->
<!--          >-->
<!--            {{dateAttestation.date}}-->
<!--          </v-tab>-->
<!--        </v-tabs>-->

<!--        <v-tabs-items v-model="tab">-->
<!--          <v-tab-item-->
<!--            v-for="dateAttestation in statistics.dateAttestations"-->
<!--            :key="`${statistics.meta.departmentName}-${dateAttestation.date}`"-->
<!--          >-->
<!--            <v-sheet class="d-flex justify-center">-->
<!--              <bar-graph-statistic-attestation-->
<!--                :xaxis="addAverageValueCodes(educationProgramCodes)"-->
<!--                :series="dataStatisticAttestationPartitionCoursesToDrawGraph(educationalAttestationStatistics(dateAttestation), educationProgramCodes)"-->
<!--              />-->
<!--            </v-sheet>-->
<!--          </v-tab-item>-->
<!--        </v-tabs-items>-->

<!--      </v-card-text>-->
<!--    </template>-->
<!--  </v-card>-->
</template>

<style scoped>

</style>